/** Display only: keep the source's team, side, line and map intact. */
const PATTERN = /^(Moneyline|Handicap|Total|Individual Total) \((Match|Map [1-5])\) (.+)$/;

function parsed(value: string) {
  const match = PATTERN.exec(value.trim());
  if (!match?.[1] || !match[2] || !match[3]) return null;
  return { family: match[1], scope: match[2] === 'Match' ? 'матч' : `карта ${match[2].slice(4)}`, value: match[3] };
}

export function polyquantOutcome(value: string): string {
  const p = parsed(value);
  if (!p) return value;
  let text: string;
  if (p.family === 'Moneyline') text = `Победа ${p.value}`;
  else if (p.family === 'Handicap') text = `Фора ${p.value}`;
  else {
    const total = /^(Over|Under) (\d+(?:\.\d+)?)$/.exec(p.value);
    if (!total) return value;
    text = `${p.family === 'Individual Total' ? 'И' : ''}Т${total[1] === 'Over' ? 'Б' : 'М'} ${total[2]}`;
  }
  return `${text} · ${p.scope}`;
}

export function polyquantMarket(value: string): string {
  const p = parsed(value);
  if (!p) return value;
  const name = { Moneyline: 'Победа', Handicap: 'Фора', Total: 'Тотал', 'Individual Total': 'Инд. тотал' }[p.family];
  return `${name} · ${p.scope}`;
}
